import React from 'react';

export default function MobileProviderLabInfo({ user, onBack }) {
  const info = [
    { icon: 'business',      label: 'Organization Name', value: user?.name || 'Apollo Diagnostics' },
    { icon: 'phone',         label: 'Phone Number',       value: user?.phone || '+91 97777 77777' },
    { icon: 'mail',          label: 'Email Address',      value: user?.email || 'apollo@diagnostics.com' },
    { icon: 'badge',         label: 'Registration No.',   value: user?.registrationNumber || 'NABL-2024-1234' },
    { icon: 'local_hospital',label: 'Provider Type',      value: user?.providerRole || 'Diagnostic Lab' },
    { icon: 'verified',      label: 'Account Status',     value: user?.status || 'Onboarded' },
  ];

  return (
    <div className="pb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
      {/* Back Header */}
      <div className="flex items-center gap-3 px-4 py-4 bg-white border-b border-gray-100 shadow-sm">
        <button onClick={onBack} className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-gray-100">
          <span className="material-symbols-outlined text-gray-500">arrow_back</span>
        </button>
        <p className="font-black text-lg text-[#141a3d]">Lab Information</p>
      </div>

      <div className="px-4 mt-4 space-y-3">
        {info.map((item, i) => (
          <div key={i} className="bg-white rounded-2xl p-4 flex items-center gap-4 shadow-sm">
            <div className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0" style={{ background: '#e1f3ee' }}>
              <span className="material-symbols-outlined" style={{ fontSize: '20px', color: '#0f6b5c', fontVariationSettings: '"FILL" 1' }}>{item.icon}</span>
            </div>
            <div>
              <p className="text-xs text-gray-400 font-semibold">{item.label}</p>
              <p className="font-extrabold text-[#141a3d] text-sm mt-0.5">{item.value}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}